import React, { ReactNode, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import './index.scss';
import { getClstag } from '@/utils/util';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/emit';
type DraweProps = {
  defaultOpened: boolean;
  direction: 'left' | 'right';
  width: number | string;
  classNames?: string;
  btnWrapperCls?: string;
  children: ReactNode;
  collapseNode: ReactNode;
  handleCollapse?: (isOpened: boolean) => void;
  handleExpand?: (isOpened: boolean) => void;
};
const Drawer = (props: DraweProps) => {
  const {
    direction,
    width,
    classNames,
    collapseNode,
    defaultOpened,
    btnWrapperCls,
    handleCollapse,
    handleExpand,
  } = props;
  const suspendedRef = useRef<HTMLDivElement>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const handleClickCollapseBtn = () => {
    if (drawerRef.current) {
      drawerRef.current.style.width = '0px';
    }
    setTimeout(() => {
      handleCollapse && handleCollapse(false);
      if (suspendedRef.current) {
        suspendedRef.current.style.display = 'block';
      }
    }, 300);
  };

  const handleClickExpand = () => {
    if (suspendedRef.current) {
      suspendedRef.current.style.display = 'none';
    }
    if (drawerRef.current) {
      drawerRef.current.style.width =
        typeof width === 'string' ? width : `${width}px`;
    }
    handleExpand && handleExpand(true);
  };
  useEffect(() => {
    addGlobalEventListener('CHANGE_DRAWER_STATUS', handleClickCollapseBtn);
    return () => {
      removeGlobalEventListener('CHANGE_DRAWER_STATUS', handleClickCollapseBtn);
    };
  }, []);
  return (
    <>
      <div
        ref={drawerRef}
        className={classnames('drawer-wrapper', {
          [classNames || '']: true,
        })}
        style={{ width: defaultOpened ? width : 0 }}
      >
        {direction === 'left' && (
          <i
            className="left-collapse-btn"
            onClick={handleClickCollapseBtn}
            clstag={getClstag(newCommon.cockpitMode, 'Drawer_Collapse')}
          />
        )}
        {props.children}
        {direction === 'right' && <i className="right-collapse-btn"></i>}
      </div>
      <div
        className={classnames('suspended-btn-area', {
          [btnWrapperCls || '']: true,
        })}
        ref={suspendedRef}
        onClick={handleClickExpand}
      >
        {collapseNode}
        <div
          className="expand-icon"
          clstag={getClstag(newCommon.cockpitMode, 'Drawer_Expand')}
        >
          <i></i>
        </div>
      </div>
    </>
  );
};

export default React.memo(Drawer);
